import { useNavigate } from "react-router";
import Github from "../icons/GIthub";
import Instagram from "../icons/Instagram";
import LinkedIn from "../icons/LinkedIn";
import Audio from "../icons/Audio";

import "./home.css";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <h1>Ben Whitfield</h1>
      <h3>Tech Lead @ ANS Group, Manchester</h3>
      <div className="links">
        <a
          href="https://github.com/BIWhitfield"
          target="_blank"
          rel="noreferrer"
        >
          <Github />
        </a>

        <a
          href="https://www.instagram.com/papiermachetes/"
          target="_blank"
          rel="noreferrer"
        >
          <Instagram />
        </a>

        <a
          href="https://www.linkedin.com/in/biwhitfield/"
          target="_blank"
          rel="noreferrer"
        >
          <LinkedIn />
        </a>

        <button className="button-icon" onClick={() => navigate("/audio")}>
          <Audio />
        </button>
      </div>
    </div>
  );
}

export default Home;
